import React from "react";
import SmartLink from "../../../utils/SmartLink";

function HomeHistorys({
    title = 'Historias MEDATA',
    text = 'Conoce las historias y casos de éxito de los usuarios del portal de datos abiertos del municipio de Medellín',
    url = '/historias' }) {


    return (
        <>
            <p className="title title--blue">
                {title}
            </p>
            <hr className="separator separator--blue" />
            <p className="text">
                {text}
            </p>
            <div className="mt-5 text-center">
                <SmartLink className="button button-conoce-mas" title="Historias" to={url}>
                    CONOCE MÁS
                </SmartLink>
            </div>
        </>

    )
}

export default HomeHistorys